import React from 'react';

export default function TextInput({onChange, ...inputProps}) {
    const handleChange = (event) => {
        if (onChange !== undefined) {
            onChange(event.target.value);
        }
    }

    return (
        <input
            className={'form-control rounded-left'}
            onChange={handleChange}
            {...inputProps}
        />
    )
}
